import {
  Activity,
  BarChart3,
  Bot,
  Building2,
  CalendarCheck,
  ClipboardCheck,
  Home,
  LayoutDashboard,
  ListChecks,
  PhoneCall,
  Pill,
  ShieldAlert,
  ScrollText,
  Settings,
  Users,
  Clock,
  type LucideIcon,
} from 'lucide-react';
import type { Role } from '../types';

export interface NavItem {
  key: string;
  path: string;
  icon: LucideIcon;
  roles: Role[];
  soon?: boolean;
}

const CLINIC: Role[] = ['facility_admin', 'doctor', 'staff'];

export const NAV_ITEMS: NavItem[] = [
  { key: 'dashboard', path: '/', icon: LayoutDashboard, roles: ['super_admin'] },
  { key: 'facilities', path: '/facilities', icon: Building2, roles: ['super_admin'] },
  { key: 'systemHealth', path: '/system-health', icon: Activity, roles: ['super_admin'] },
  { key: 'agents', path: '/agents', icon: Bot, roles: ['super_admin'] },
  { key: 'protocols', path: '/protocols', icon: ListChecks, roles: ['super_admin'] },
  { key: 'audit', path: '/audit', icon: ScrollText, roles: ['super_admin'] },
  { key: 'guardrails', path: '/guardrails', icon: ShieldAlert, roles: ['super_admin'] },
  // Clinic menu kept short: daily work only. Set-once things (script sign-off, schedule, staff, safety
  // review) live under Settings or inside Calls; those routes still work for links and the tour.
  { key: 'today', path: '/', icon: Home, roles: CLINIC },
  { key: 'patients', path: '/patients', icon: Users, roles: CLINIC },
  { key: 'attendance', path: '/attendance', icon: CalendarCheck, roles: ['staff'] },
  // Reception sets visit time slots here (doctors and the clinic admin use Settings → Visit time slots).
  { key: 'slots', path: '/slots', icon: Clock, roles: ['staff'] },
  { key: 'calls', path: '/calls', icon: PhoneCall, roles: CLINIC },
  { key: 'prescriptions', path: '/prescriptions', icon: Pill, roles: ['doctor'] },
  { key: 'reports', path: '/reports', icon: BarChart3, roles: ['facility_admin', 'doctor'] },
  { key: 'settings', path: '/settings', icon: Settings, roles: ['facility_admin', 'doctor'] },
];

export const navFor = (role: Role) => NAV_ITEMS.filter((i) => i.roles.includes(role));

export const ROLES: Role[] = ['super_admin', 'facility_admin', 'doctor', 'staff'];

export const QUICK_ICON = ClipboardCheck;
